import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import { HELP_CENTER_URL } from '../constants';
var DropdownHelpCenterLink = function DropdownHelpCenterLink(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Get help' : _ref$label;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("a", {
    "aria-label": t(label),
    className: "dropdown-item fw-normal",
    href: HELP_CENTER_URL
  }, /*#__PURE__*/React.createElement(T, {
    source: label
  }));
};
export default DropdownHelpCenterLink;